import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from "./components/Layout";
import Public from "./components/Public";
import Login from "./features/auth/Login";
import DashLayout from "./components/DashLayout";
import UsersList from "./features/users/UsersList";
import NewUserForm from "./features/users/NewUserForm";
import Prefetch from "./features/auth/Prefetch";
import PersistLogin from "./features/auth/PersistLogin";
import RequireAuth from "./features/auth/RequireAuth";
import { ROLES } from "./config/roles";
import useTitle from "./hooks/useTitle";
import AnalitikaMain from "./features/analitika/AnalitikaMain";
import Dashboard from "./features/dashboard/Dashboard";
import EditUserProfile from "./features/users/EditUserProfile";
// import Obracuni from "./features/obracuni/Obracuni";
// import NewObracun from "./features/obracuni/NewObracun";
// import EditObracun from "./features/obracuni/EditObracun";
// import PreviewObracun from "./features/obracuni/PreviewObracun";

//Podaci
// import PozicijeList from "./features/podaci/pozicije/PozicijeList";
// import SektorList from "./features/podaci/sektor/SektorList";
// import TipOrganizacijeList from "./features/podaci/tipOrganizacije/TipOrganizacijeList";
// import TipUgovoraList from "./features/podaci/tipUgovora/TipUgovoraList";

//Testing
// import OrganizacijaList from "./features/organizacija/OrganizacijaList";
// import EditOrganizacijaProfile from "./features/organizacija/EditOrganizacijaProfile";
import Reset from "./features/auth/Reset";
import Email from "./features/auth/Email";
import Register from "./features/auth/Register";
import { GoogleOAuthProvider } from "@react-oauth/google";
import GoogleLogin from "./features/auth/GoogleLogin";
import AdminChat from "./features/openai/AdminChat";
import EditUserForm from "./features/users/EditUserForm";
import EditUser from "./features/users/EditUser";
import Podesavanja from "./features/settings/Podesavanja";
import Kalkulacije from "./features/kalkulacije/Kalkulacije";
import Proba from "./components/Proba";
import useAuth from "./hooks/useAuth";
import MojDnevnik from "./features/mojdnevnik/MojDnevnik";
import BodyFatCalculator from "./components/BodyFatCalculator";
import Radios from "./components/Radios";
import NamirnicaForm from "./components/NamirnicaForm";
import IshranaForm from "./components/IshranaForm";
import LongSection from "./components/LongSection";
import IshranaTable from "./components/IshranaTable";
import SpecCilj from "./components/SpecCilj";
import NaminicaFormAliSamoCiljevi from "./components/NaminicaFormAliSamoCiljevi";
import AlergijeNaHran from "./features/users/AlergijeNaHran";
import ProbaNav from "./components/ProbaNav";
import IzborPaketa from "./features/pretplata/IzborPaketa";
import TermAndConditions from "./features/pretplata/TermAndConditions";
import SviPaketi from "./features/pretplata/SviPaketi";
import Create from "./features/Blog/Create";
import BlogDetails from "./features/Blog/BlogDetails";
import BlogList from "./features/Blog/BlogList";
import BlogListAdmin from "./features/Blog/BlogListAdmin";
import BlogDetailsAdmin from "./features/Blog/BlogDetailsAdmin";
import BlogListPublic from "./features/Blog/BlogListPublic";
import BlogDetailsPublic from "./features/Blog/BlogDetailsPublic";
import BlogIzmeni from "./features/Blog/BlogIzmeni";
import GoogleCallback from "./features/auth/GoogleCallback";
import ProtectedRoute from "./features/auth/ProtectedRoute";
import HighlightText from "./components/HighlightText";
import Help from "./features/pretplata/Help";
import Vodic from "./components/Vodic";

//NAPOMENA => za edit je korisceno EditUserProfile umesto EditUser i  tako za ostale skripte

function App() {
  useTitle("NutriTrans");
  const { isKlijent, isAdmin } = useAuth();

  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag("config", "G-L79HL59W9Y", {
        page_path: location.pathname,
      });
    }
  }, [location]);

  const GoogleAuthWrapper = () => {
    return (
      <GoogleOAuthProvider clientId="354969527200-9nh63h9p7fr6qnqftajlg42vrcgje4ht.apps.googleusercontent.com">
        <GoogleLogin />
      </GoogleOAuthProvider>
    );
  };

  let osoba = {
    bmi: {
      "24/5/2023": 27.4,
      "1/8/2023": 21.2,
      "3/8/2024": 30.7,
      "14/7/2024": 25.1,
    },
  };

  return (
    // <div className="min-h-screen bg-gray-200">
    //   <Routes>
    //     <Route path="/" element={<Layout />}>
    //       {/* public routes */}
    //       <Route index element={<Public />} />
    //       <Route path="login" element={<Login />} />

    //       {/* <Route path="login2" element={<GoogleAuthWrapper />} /> */}

    //       {/* Unos emaila za reset sifre, */}
    //       <Route path="reset" element={<Email />} />

    //       {/* Reset sifre */}
    //       <Route path="email" element={<Reset />} />

    //       {/* Register */}
    //       <Route path="register" element={<Register />} />

    //       {/* Protected Routes */}
    //       <Route element={<PersistLogin />}>
    //         <Route
    //           element={<RequireAuth allowedRoles={[...Object.values(ROLES)]} />}
    //         >
    //           <Route element={<Prefetch />}>
    //             <Route path="dash" element={<DashLayout />}>
    //               <Route index element={<Dashboard />} /> {/* Admin */}
    //               <Route path="test" element={<Test />} />
    //               <Route path="projects" element={<Test />} />
    //               <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
    //                 <Route path="users">
    //                   <Route index element={<UsersList />} />
    //                   <Route path=":id" element={<EditUserProfile />} />
    //                   <Route path="new" element={<NewUserForm />} />
    //                 </Route>
    //               </Route>
    //               <Route
    //                 element={<RequireAuth allowedRoles={[ROLES.Editor]} />}
    //               ></Route>
    //             </Route>
    //             {/* End Dash */}
    //           </Route>
    //         </Route>
    //       </Route>
    //       {/* End Protected Routes */}
    //     </Route>
    //   </Routes>
    // </div>

    //Example za postavljenje slike zbog propertija
    //   <div
    //   style={{
    //     backgroundImage: 'url("/background.jpg")', // Path to your image in the public folder
    //     backgroundSize: 'cover',
    //     backgroundPosition: 'center',
    //     height: '100vh',
    //     width: '100%',
    //     display: 'flex',
    //     alignItems: 'center',
    //     justifyContent: 'center',
    //     color: 'white',
    //     textAlign: 'center',
    //   }}
    // >

    // <div className="min-h-screen bg-gray-200"  style={{ backgroundImage: 'url("/img/pozadina.jpg")', backgroundSize: 'cover'}}>
    // <div className={`min-h-screen ${isAdmin ? 'bg-blue-500' : isKlijent ? 'bg-green-500' : 'bg-gray-200'}`}
    //       style={{ backgroundImage: !isAdmin && !isKlijent ? 'url("/img/pozadina.jpg")' : 'none', backgroundSize: 'cover'}}>

    // <div className="responsive-background">

    <div>
      <Routes>
        <Route path="/" element={<Layout />}>
          {/* Public routes */}
          <Route index element={<Public />} />
          <Route path="login" element={<Login />} />
          <Route path="register" element={<Register />} />{" "}
          {/* Ovo se desava na serverskoj strani */}
          <Route path="reset" element={<Email />} />
          <Route path="email" element={<Reset />} />
          <Route path="test" element={<LongSection />} />
          <Route path="proba" element={<NamirnicaForm />} />
          <Route path="proba1" element={<IshranaForm />} />
          <Route path="proba2" element={<IshranaTable />} />
          <Route path="proba3" element={<SpecCilj />} />
          <Route path="proba4" element={<NaminicaFormAliSamoCiljevi />} />
          <Route path="terms" element={<TermAndConditions />} />
          <Route path="help" element={<Help />} />
          <Route path="vodic" element={<Vodic />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          {/* Blog rute */}
          <Route path="blogsPublic" element={<BlogListPublic />} />
          <Route path="blogsPublic/:id" element={<BlogDetailsPublic />} />
          <Route path="/auth/callback" element={<GoogleCallback />} />
          <Route path="/highlight" element={<HighlightText />} />
          {/* <Route path="/blogs/:id">
            <BlogDetails></BlogDetails>
          </Route> */}
          {/* Protected Routes */}
          {/* <Route element={<PersistLogin />}>
            <Route element={<Prefetch />}>
              <Route path="dash" element={<DashLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="terms" element={<TermAndConditions />} />
         
                <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
                  <Route path="users" element={<UsersList />} />
                  <Route path="users/:id" element={<EditUserProfile />} />
                  <Route path="/dash/chat" element={<AdminChat />} />
                  <Route path="/dash/podesavanja" element={<Podesavanja />} />

                  <Route path="/dash/create" element={<Create />} />
                </Route>

                <Route element={<RequireAuth allowedRoles={[ROLES.Klijent]} />}>
                  <Route index element={<Reset />} />
                  <Route path="/dash/user/:id" element={<EditUser />} />
                  <Route path="/dash/mojdnevnik" element={<MojDnevnik />} />
                  <Route path="/dash/kalkulacije" element={<Kalkulacije />} />
                  <Route path="sviPaketi" element={<SviPaketi />} />
                  <Route path="probaProfNav" element={<IzborPaketa />} />

             

                  <Route path="/dash/blogs" element={<BlogList />}>
                    <Route path=":id" element={<BlogDetails />} />{" "}
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route> */}
          <Route element={<PersistLogin />}>
            {/* <Route element={<Prefetch />}> */}

            <Route path="dash" element={<DashLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="terms" element={<TermAndConditions />} />

              {/* Admin-Specific Routes */}
              <Route element={<RequireAuth allowedRoles={[ROLES.Admin]} />}>
                <Route path="users" element={<UsersList />} />
                <Route path="users/:id" element={<EditUserProfile />} />
                <Route path="chat" element={<AdminChat />} />
                <Route path="podesavanja" element={<Podesavanja />} />
                {/* <Route path="create" element={<Create />} /> */}

                {/* Blog rute */}
                <Route path="blogsAdmin" element={<BlogListAdmin />} />
                <Route path="blogsAdmin/:id" element={<BlogDetailsAdmin />} />
                <Route path="blogsAdmin/izmeni/:id" element={<BlogIzmeni />} />
              </Route>

              {/* Klijent-Specific Routes */}
              <Route element={<RequireAuth allowedRoles={[ROLES.Klijent]} />}>
                <Route index element={<Reset />} />
                <Route path="user/:id" element={<EditUser />} />
                <Route path="mojdnevnik" element={<MojDnevnik />} />
                <Route path="kalkulacije" element={<Kalkulacije />} />
                <Route path="sviPaketi" element={<SviPaketi />} />
                <Route path="probaProfNav" element={<IzborPaketa />} />

                {/* Blog rute */}
                <Route path="blogs" element={<BlogList />} />
                <Route path="blogs/:id" element={<BlogDetails />} />
              </Route>
            </Route>
            {/* </Route> */}
          </Route>
        </Route>
      </Routes>
    </div>

    // </div>
  );
}

export default App;

{
  /* <table className="min-w-full bg-white border border-gray-200">
      <thead>
        <tr>
          <th className="px-4 py-2 border">Naziv</th>
          <th className="px-4 py-2 border">Grupa</th>
          <th className="px-4 py-2 border">Podtip</th>
          <th className="px-4 py-2 border">Laktoza</th>
          <th className="px-4 py-2 border">Gluten</th>
          <th className="px-4 py-2 border">Alergen</th>
          {availableIshrane.length > 0 ? (
            availableIshrane.map((ishrana) => (
              <th key={ishrana._id || ishrana} className="px-4 py-2 border">
                {ishrana.naziv || ishrana}
              </th>
            ))
          ) : (
            <th className="px-4 py-2 border">Nema dostupnih ishrana</th>
          )}
        </tr>
      </thead>
      <tbody>
        {Array.isArray(namirnice) && namirnice.length > 0 ? (
          namirnice.map((namirnica) => (
            <tr key={namirnica._id}>
              <td className="px-4 py-2 border">{namirnica.naziv}</td>
              <td className="px-4 py-2 border">{namirnica.grupa}</td>
              <td className="px-4 py-2 border">{namirnica.podtip}</td>
              <td className="px-4 py-2 border">{namirnica.laktoza ? 'Da' : 'Ne'}</td>
              <td className="px-4 py-2 border">{namirnica.gluten ? 'Da' : 'Ne'}</td>
              <td className="px-4 py-2 border">{namirnica.alergen ? 'Da' : 'Ne'}</td>

              {availableIshrane.map((ishrana) => (
                <td key={ishrana._id || ishrana} className="px-4 py-2 border text-center">
                  <input
                    type="checkbox"
                    checked={namirnica.ishrane.includes(ishrana.naziv || ishrana)}
                    readOnly
                  />
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={availableIshrane.length + 6} className="px-4 py-2 border text-center">
              Nema dostupnih namirnica.
            </td>
          </tr>
        )}
      </tbody>
    </table> */
}
